import request from '@/plugins/axios'

// 标签分组列表
export const apiTagGroupList = (params: any) => request.get('/operating.group_welfare.tag/groupList', { params })

// 添加标签分组
export const apiTagGroupEdit = (data: any) => request.post('/operating.group_welfare.tag/groupEdit', data)

// 删除标签或分组
export const apiTagDel = (data: any) => request.post('/operating.group_welfare.tag/del', data)

// 标签列表
export const apiTagList = (params: any) => request.get('/operating.group_welfare.tag/tagList', { params })

// 添加标签
export const apiTagEdit = (data: any) => request.post('/operating.group_welfare.tag/tagEdit', data)

// 获取全部标签
export const apiAllTagList = () => request.get('/operating.group_welfare.tag/tags')


